import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Eye, Download, Users, Sparkles, Star, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
interface SignupModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  action: 'view' | 'download';
}
export const SignupModal: React.FC<SignupModalProps> = ({
  open,
  onOpenChange,
  action
}) => {
  return <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm bg-gradient-to-br from-slate-900 to-purple-900 border-white/20 text-white">
        <DialogHeader className="text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-xl flex items-center justify-center mx-auto mb-4">
            {action === 'view' ? <Eye className="h-8 w-8 text-white" /> : <Download className="h-8 w-8 text-white" />}
          </div>
          <DialogTitle className="text-xl text-white">
            Want to {action === 'view' ? 'view' : 'download'} your image?
          </DialogTitle>
          <DialogDescription className="text-gray-300">
            Sign up now - it's super easy and you'll get amazing benefits!
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {/* Benefits */}
          <div className="space-y-3">
            <div className="flex items-center space-x-3 p-3 bg-white/5 rounded-lg border border-white/10">
              <div className="w-8 h-8 bg-green-500/20 rounded-full flex items-center justify-center">
                <Sparkles className="h-4 w-4 text-green-400" />
              </div>
              <div>
                <p className="font-medium text-white">250 Free Credits</p>
                <p className="text-xs text-gray-400">Generate hundreds of images</p>
              </div>
            </div>

            <div className="flex items-center space-x-3 p-3 bg-white/5 rounded-lg border border-white/10">
              <div className="w-8 h-8 bg-purple-500/20 rounded-full flex items-center justify-center">
                <Download className="h-4 w-4 text-purple-400" />
              </div>
              <div>
                <p className="font-medium text-white">Full Resolution Downloads</p>
                <p className="text-xs text-gray-400">Get your images in highest quality</p>
              </div>
            </div>

            <div className="flex items-center space-x-3 p-3 bg-white/5 rounded-lg border border-white/10">
              <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center">
                <Zap className="h-4 w-4 text-blue-400" />
              </div>
              <div>
                <p className="font-medium text-white">Advanced Features</p>
                <p className="text-xs text-gray-400">Access all AI models & settings</p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-2 pt-6">
            <Link to="/auth?mode=signup" className="flex-1">
              <Button 
                onClick={() => onOpenChange(false)} 
                className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white border-0 h-10 text-sm" 
                size="sm"
              >
                <Users className="w-3 h-3 mr-1" />
                Sign Up Free
              </Button>
            </Link>
            
            <Button 
              variant="outline" 
              onClick={() => onOpenChange(false)} 
              className="flex-1 text-white border-white/20 bg-white/5 hover:bg-white/10 h-10 text-sm"
              size="sm"
            >
              Maybe Later
            </Button>
          </div>

          <div className="text-center">
            <Badge className="bg-yellow-500/20 text-yellow-300 border-yellow-500/30">
              <Star className="w-3 h-3 mr-1" />
              No credit card required
            </Badge>
          </div>
        </div>
      </DialogContent>
    </Dialog>;
};